// extracted by mini-css-extract-plugin
export default {"popper":"Tooltip_popper__GPZyB","arrow":"Tooltip_arrow__gvMhN"};